import { el } from './dom.js';

/**
 * 物件の切り替えプルダウン。
 * 物件が1件しかないときは出さない（選ぶ意味がないため）。
 */
export function createPropertySwitcher(container, { properties, currentId, onSelect }) {
  if (!Array.isArray(properties) || properties.length < 2) return null;

  const select = el(
    'select',
    { class: 'ps-select', 'aria-label': '物件を選ぶ' },
    properties.map((p) => {
      // スキャン未登録の物件は選べないようにする。選ばせるとエラー画面になるため
      const pending = p.ready === false;
      return el(
        'option',
        {
          value: p.id,
          ...(p.id === currentId ? { selected: 'selected' } : {}),
          ...(pending ? { disabled: 'disabled' } : {}),
        },
        pending ? `${p.name}（スキャン準備中）` : p.name,
      );
    }),
  );

  select.addEventListener('change', () => onSelect(select.value));

  // ツールバーの中に入れる。絶対配置で重ねると画面幅によって
  // 「視点を戻す」などのボタンと衝突するため、同じ flex 行に並べる。
  const toolbar = container.querySelector('.toolbar');
  const parent = toolbar ?? container;
  const root = el('div', { class: 'ps' }, select);
  parent.appendChild(root);
  return { root };
}

/** 公開されている物件の一覧を取る。失敗しても内見自体は続けられるよう空で返す */
export async function fetchPropertyList() {
  try {
    const res = await fetch('/api/properties', { headers: { accept: 'application/json' } });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data?.properties) ? data.properties : [];
  } catch (error) {
    console.error('[naiken-3dgs] 物件一覧の取得に失敗', error);
    return [];
  }
}
